/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fill: "none",
  transform: "matrix(0.57213929,0,0,0.57213929,0.5572142,0.5572142)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "20",
  r: "19.6",
  fill: "#ffffff",
  fillOpacity: "0.5",
  stroke: "#a400e1"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#a400e1"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 14.73,4.21 c -0.397,-0.378 -1,-0.357 -1.376,0.022 -0.375,0.4 -0.354,1.01 0.021,1.39 0.646,0.63 1,1.452 1,2.357 0,0.905 -0.354,1.726 -1,2.358 -0.396,0.379 -0.396,1.01 -0.02,1.39 0.187,0.21 0.457,0.294 0.707,0.294 0.25,0 0.48,-0.084 0.688,-0.274 1.02,-0.99 1.583,-2.336 1.583,-3.79 C 16.313,6.568 15.75,5.221 14.729,4.211 Z",
  transform: "translate(10,12)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 16.958,1.39 c -0.395,-0.358 -1.02,-0.337 -1.375,0.084 -0.354,0.4 -0.333,1.031 0.084,1.39 1.437,1.304 2.27,3.178 2.27,5.136 0,1.958 -0.833,3.832 -2.27,5.137 -0.396,0.358 -0.438,0.99 -0.084,1.39 0.188,0.21 0.459,0.336 0.73,0.336 0.229,0 0.458,-0.084 0.645,-0.252 C 18.813,12.926 19.875,10.526 19.875,8 19.895,5.474 18.833,3.074 16.958,1.39 Z M 10.104,0.168 4.208,4.611 H 0.688 C 0.354,4.611 0.104,4.884 0.104,5.2 v 5.579 c 0,0.337 0.271,0.59 0.584,0.59 h 3.52 l 5.896,4.463 c 0.396,0.294 0.938,0.02 0.938,-0.485 V 0.632 c 0,-0.485 -0.563,-0.758 -0.938,-0.464 z",
  transform: "translate(10,12)"
}))), 'PodcastCircle');